<template>
    <div id="record-container">
        <button v-if="audio.url" class="btn" @click.prevent="handleDelete" title="Delete existing recording">
            <i class="fa-solid fa-trash la-lg text-danger"></i>
        </button>
        <button v-else class="btn" @click.prevent="toggleRecordStop">
            <i v-if="isRecording" class="fa-solid fa-circle-stop fa-beat-fade fa-lg text-danger" title="Stop recording"></i>
            <i v-else class="fa-solid fa-circle fa-lg text-danger" title="Start recording"></i>
        </button>

        <Timer style="color: white" v-if="!audio.url" :limit="60 * 15" :disabled="!isRecording" @limitreached="handleRecordLimitReached" />

        <Player :source="audio" :disabled="isRecording"/>

        <button type="button" :disabled="!audio.url" class="btn" title="Download">
            <a :href="audio.url" download="recorded-audio.wav">
                <i class="fa-solid fa-circle-down fa-lg"></i>
            </a>
        </button>
    </div>
</template>


<script>
import Player from './Player.vue'
import Timer from '../Utilities/Timer.vue';
import { createFFmpeg } from "@ffmpeg/ffmpeg"
import { setItem, getItem, clearItems } from '../../assets/js/storage'

export default {
    components: { Player, Timer },
    props: ['value'],
    emits: ['recordstart', 'recordend', 'input'],
    data() {
        return {
            isRecording: false,
            mediaRecorder: null,
            audioChunks: [],
            audio: {
                url: null,
                duration: 0
            },
        }
    },
    mounted() {
        getItem('recorded-audio').then(data => {
            if(!data) return

            const blob = new Blob([data.buffer])
            this.audio = {
                url: window.URL.createObjectURL(blob),
                duration: data.duration
            }
            const audioFile = new File([blob], `audio-${new Date().toISOString()}.wav`, { type: 'audio/wav' });
            this.$emit('recordend', audioFile);
            this.$emit('input', audioFile)
        })
    },
    methods: {
        toggleRecordStop() {
            if (!this.isRecording) {
                this.startRecording()
            } else {
                this.stopRecording()
            }
        },
        handleRecordLimitReached() {
            this.stopRecording()
        },
        handleDelete() {
            this.g2dialog.$confirm("You are about to delete an audio recording. Continue?").then((confirmed) => {
                if(confirmed) {
                    clearItems()
                    this.audio = { url: '' }
                    this.$emit('input', null)
                }
            })
        },
        startRecording() {
            if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
                navigator.mediaDevices.getUserMedia({ audio: true })
                    .then(stream => {
                        const mimeType = 'audio/webm;codecs=opus';
                        const audioContext = new (window.AudioContext || window.webkitAudioContext)();
                        this.mediaRecorder = new MediaRecorder(stream, { mimeType });
                        this.mediaRecorder.ondataavailable = (e) => {
                            this.audioChunks.push(e.data);
                        };
                        this.mediaRecorder.onstart = () => {
                            this.startTime = audioContext.currentTime;
                        }
                        this.mediaRecorder.onstop = () => {
                            const endTime = audioContext.currentTime;
                            const duration = (endTime - this.startTime);
                            const filename = `audio-${new Date().toISOString()}`
                            const blob = new Blob(this.audioChunks, { type: "audio/webm" });
                            this.audioChunks = [];
                            
                            const reader = new FileReader();
                            reader.onloadend = (e) => {
                                const sourceBuffer = e.target.result
                                this.ffmpeg.FS('writeFile', 'recorded.webm', new Uint8Array(sourceBuffer, 0, sourceBuffer.byteLength))
                                this.ffmpeg.run('-i', 'recorded.webm', '-ar', '44100', '-ac', '1', 'recorded.wav').then(e => {
                                    const converted = this.ffmpeg.FS('readFile', 'recorded.wav')
                                    const convertedBlob = new Blob([converted.buffer], { type: 'audio/wav' })
                                    let audioFile = new File([convertedBlob], `${filename}.wav`, { type: 'audio/wav' });
                                    this.audio = { url: window.URL.createObjectURL(convertedBlob), duration }
                                    setItem('recorded-audio', { buffer: converted.buffer, duration })
                                    this.$emit('recordend', audioFile);
                                    this.$emit('input', audioFile);
                                })
                            };
                            reader.readAsArrayBuffer(blob);
                            
                        };
                        this.ffmpeg = createFFmpeg({ log: true })
                        this.ffmpeg.load().then(() => {
                            this.$emit('recordstart');
                            this.mediaRecorder.start();
                            this.isRecording = true;
                        })
                    })
                    .catch(err => {
                        console.error(err);
                    });
            }
        },
        stopRecording() {
            this.mediaRecorder.stop();
            this.isRecording = false;
        }
    }
}
</script>


<style scoped>
#record-container {
    display: flex;
    align-items: center;
    justify-content: space-around;
    background-color: #036;
    border-radius: 0.75rem;
    padding: 0.15rem;
    width: 100%;
}

#record-container i {
    color: white;
}
#record-container button[disabled] {
    cursor: not-allowed;
}
</style>